/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessSpecialInstructionsBody
 */
export interface UpdateBusinessSpecialInstructionsBody {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBusinessSpecialInstructionsBody
     */
    specialInstructions: boolean;
}

/**
 * Check if a given object implements the UpdateBusinessSpecialInstructionsBody interface.
 */
export function instanceOfUpdateBusinessSpecialInstructionsBody(value: object): value is UpdateBusinessSpecialInstructionsBody {
    if (!('specialInstructions' in value) || value['specialInstructions'] === undefined) return false;
    return true;
}

export function UpdateBusinessSpecialInstructionsBodyFromJSON(json: any): UpdateBusinessSpecialInstructionsBody {
    return UpdateBusinessSpecialInstructionsBodyFromJSONTyped(json, false);
}

export function UpdateBusinessSpecialInstructionsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessSpecialInstructionsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'specialInstructions': json['specialInstructions'],
    };
}

export function UpdateBusinessSpecialInstructionsBodyToJSON(json: any): UpdateBusinessSpecialInstructionsBody {
    return UpdateBusinessSpecialInstructionsBodyToJSONTyped(json, false);
}

export function UpdateBusinessSpecialInstructionsBodyToJSONTyped(value?: UpdateBusinessSpecialInstructionsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'specialInstructions': value['specialInstructions'],
    };
}

